// Input.js
import { Label } from "./label";
import { Error } from "./error";

export const Input = ({
  type,
  name,
  label,
  error,
  registration,
  className,
  ...props
}) => (
  <div className="mb-3">
    {label && <Label htmlFor={name}>{label}</Label>}
    <input
      type={type}
      name={name}
      className={`form-control ${className || ""}`}
      {...registration}
      {...props}
    />
    <Error errorMessage={error?.message} />
  </div>
);

export const CInput = ({ type, name, label, error, className, ...props }) => (
  <div className="mb-3">
    {label && <Label htmlFor={name}>{label}</Label>}
    <input
      type={type}
      name={name}
      className={`form-control ${className || ""}`}
      {...props}
    />
    <Error errorMessage={error?.message} />
  </div>
);
